import * as betgalaxy from './Flucs.styles.betgalaxy';
import * as betprofessor from './Flucs.styles.betprofessor';
import * as betroyale from './Flucs.styles.betroyale';
import * as fiestabet from './Flucs.styles.fiestabet';
import * as goldenrush from './Flucs.styles.goldenrush';
import * as juicybet from './Flucs.styles.juicybet';
import * as junglebet from './Flucs.styles.junglebet';
import * as puntgenie from './Flucs.styles.puntgenie';
import * as questbet from './Flucs.styles.questbet';
import * as sterlingparker from './Flucs.styles.sterlingparker';
import * as puntcity from './Flucs.styles.puntcity';
import * as vikingbet from './Flucs.styles.vikingbet';
import * as volcanobet from './Flucs.styles.volcanobet';
import * as wellbet from './Flucs.styles.wellbet';
import * as sugarcastle from './Flucs.styles.sugarcastle';
import * as oldgill from './Flucs.styles.oldgill';
import * as buffalobet from './Flucs.styles.buffalobet';
import * as titanbet from './Flucs.styles.titanbet';
import * as slambet from './Flucs.styles.slambet';
import * as gigabet from './Flucs.styles.gigabet';
import * as betstride from './Flucs.styles.betstride';
import * as templebet from './Flucs.styles.templebet';
import * as goldenbet888 from './Flucs.styles.goldenbet888';
import * as hyperbet from './Flucs.styles.hyperbet';
import * as bet777 from './Flucs.styles.bet777';
import * as chromabet from './Flucs.styles.chromabet';
import * as bet575 from './Flucs.styles.bet575';
import * as epicodds from './Flucs.styles.epicodds';
import * as pyramidbet from './Flucs.styles.pyramidbet';
import * as magnumbet from './Flucs.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  junglebet,
  puntgenie,
  questbet,
  sterlingparker,
  puntcity,
  wellbet,
  vikingbet,
  volcanobet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
